<template>
  <div>
    <PageHeader title="My Account" showBack />
    <div class="card p-4">
      <b-form @submit.prevent="handleSave">
        <b-row>
          <b-col md="6">
            <b-form-group label="First Name" label-class="form-label">
              <b-form-input v-model="form.first_name" placeholder="First name" required />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Last Name" label-class="form-label">
              <b-form-input v-model="form.last_name" placeholder="Last name" required />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Email" label-class="form-label">
          <b-form-input v-model="form.email" type="email" placeholder="Email" required />
        </b-form-group>
        <b-button type="submit" variant="primary" :disabled="isSaving">{{ isSaving ? 'Saving...' : 'Save Changes' }}</b-button>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageHeader from '../../components/Ui/PageHeader.vue';

export default {
  name: 'MyAccount',
  components: { PageHeader },
  data() {
    return {
      form: { first_name: '', last_name: '', email: '' },
      isSaving: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
  },
  methods: {
    async handleSave() {
      this.isSaving = true;
      try {
        const userId = this.getLoggedInUser.id;
        await this.$store.dispatch('user/updateUser', { id: userId, data: this.form });
        this.makeToast('success', 'Account updated');
      } catch (err) {
        this.makeToast('danger', 'Failed to update account');
      } finally {
        this.isSaving = false;
      }
    },
  },
  created() {
    const u = this.getLoggedInUser;
    if (u) {
      this.form.first_name = u.first_name || '';
      this.form.last_name = u.last_name || '';
      this.form.email = u.email || '';
    }
  },
};
</script>
